var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevicesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6667 13.333H19.3334C17.8607 13.333 16.6667 14.5269 16.6667 15.9997V31.9997C16.6667 33.4724 17.8607 34.6663 19.3334 34.6663H28.6667C30.1395 34.6663 31.3334 33.4724 31.3334 31.9997V15.9997C31.3334 14.5269 30.1395 13.333 28.6667 13.333Z",
    stroke: "#CC0000",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0001 16H20.0001C19.2637 16 18.6667 16.597 18.6667 17.3333V21.3333C18.6667 22.0697 19.2637 22.6667 20.0001 22.6667H28.0001C28.7365 22.6667 29.3334 22.0697 29.3334 21.3333V17.3333C29.3334 16.597 28.7365 16 28.0001 16Z",
    stroke: "#CC0000",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 32.0003C25.4727 32.0003 26.6666 30.8064 26.6666 29.3337C26.6666 27.8609 25.4727 26.667 23.9999 26.667C22.5272 26.667 21.3333 27.8609 21.3333 29.3337C21.3333 30.8064 22.5272 32.0003 23.9999 32.0003Z",
    stroke: "#CC0000",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 30.0003C24.3681 30.0003 24.6666 29.7018 24.6666 29.3337C24.6666 28.9655 24.3681 28.667 23.9999 28.667C23.6317 28.667 23.3333 28.9655 23.3333 29.3337C23.3333 29.7018 23.6317 30.0003 23.9999 30.0003Z",
    fill: "#CC0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicesActive);
export default __webpack_public_path__ + "static/media/devices-active.91cb2a60e36dbe0d090ee2533a374ca5.svg";
export { ForwardRef as ReactComponent };